import { TViewPortionAction, ViewPortionActionTypes } from './viewPortionActions';
import { IViewPortionState } from './viewPortionContext';

export const viewPortionReducer = (state: IViewPortionState, action: TViewPortionAction): IViewPortionState => {
	switch (action.type) {
		case ViewPortionActionTypes.SET_DATA:
			return {
				...state,
				portionFullInfo: action.payload.portionFullInfo,
			};
		case ViewPortionActionTypes.SET_PORTION_MODIFIER_GROUP_ID:
			return {
				...state,
				portionModifierGroupId: action.payload.portionModifierGroupId,
				portionModifierGroupModifiers: action.payload.portionModifierGroupModifiers,
			};
		case ViewPortionActionTypes.SET_PORTION_MODIFIER_GROUP_MODIFIERS:
			return {
				...state,
				portionModifierGroupModifiers: action.payload.portionModifierGroupModifiers,
			};
		case ViewPortionActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		default:
			return state;
	}
};
